import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
};

const NoImage: React.FC<Props> = ({ className, width, height, fill = 'none', stroke }) => (
  <svg className={className} fill={fill} viewBox="0 0 24 24" width={width} height={height} stroke={stroke}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

export default NoImage;
